export function isNotNull<T>(nullableItem: T | null): nullableItem is T {
  return nullableItem !== null;
}
